@import "@/styles/variables";

.headerGlobal {
	width: 100%;
	height: 8.5%;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
	position: relative;
	z-index: 100;

	@media (max-width: 750px) {
		height: auto;
		min-height: 56px;
	}
}

.header {
	background-color: white;
	width: 100%;
	height: 100%;
	margin: 0;
	display: flex;
	align-items: center;
	padding: 0 15px;

	@media (max-width: 750px) {
		padding: 10px 14px;
		min-height: 56px;
		justify-content: space-between;
		gap: 0.75rem;
	}
}

.colLogo {
	display: flex;
	align-items: center;
	flex-shrink: 0;
	flex-basis: 16.666%;

	@media (max-width: 750px) {
		flex-basis: auto;
		flex-shrink: 0;
	}
}

.logo_sidebar {
	cursor: pointer;
	margin-right: 15px;
	color: $gray-700;
	flex-shrink: 0;

	@media (max-width: 750px) {
		margin-right: 0;
	}
}

.logo_sidebar_green {
	cursor: pointer;
	margin-right: 15px;
	color: $primary-color;
	flex-shrink: 0;

	@media (max-width: 750px) {
		margin-right: 0;
	}
}

.logo {
	@media (max-width: 750px) {
		display: none;
	}
}

.center_logo {
	display: none;
	justify-content: center;
	align-items: center;

	@media (max-width: 750px) {
		display: flex !important;
		flex: 1 1 auto;
		min-width: 0;
		justify-content: center;

		svg {
			width: 7em !important;
			max-width: 120px !important;
		}
	}
}

// Search section (sin customer: 8/12 = 66.666%, con customer: 6/12 = 50%)
.search {
	display: flex;
	align-items: center;
	flex-shrink: 1;
	flex-grow: 1;
	min-width: 0;

	@media (max-width: 750px) {
		display: none !important;
	}
}

.searchWrapper {
	display: flex;
	align-items: center;
	width: 100%;
	gap: 0;
}

.searchSelector {
	flex-basis: 180px;
	flex-shrink: 0;
	min-width: 150px;
}

.searchInputWrapper {
	display: flex;
	align-items: center;
	flex: 1;
	min-width: 0;

	input {
		width: 100%;
		padding: 10px 12px;
		border: 1px solid $primary-color;
		border-radius: 10px 0 0 10px;
		border-right: none;
		font-size: 14px;
		line-height: 1.5;
		height: 44px;

		&:focus {
			outline: none !important;
			border-color: $primary-hover;
		}

		&::placeholder {
			color: $primary-color;
		}

		&.withSelector {
			border-radius: 0;
			border-left: none;
		}
	}

	.searchButton {
		width: 44px;
		height: 44px;
		cursor: pointer;
		background-color: $primary-color;
		border: none;
		border-radius: 0 10px 10px 0;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		transition: background-color 0.2s ease;
		flex-shrink: 0;

		&:hover {
			background-color: $secondary-color;
		}

		&:active {
			transform: scale(0.95);
		}
	}
}

.select_customer {
	display: flex;
	align-items: center;
	flex-basis: 200px;
	flex-shrink: 0;
	margin-left: 15px;

	@media (max-width: 750px) {
		display: none !important;
	}
}

.colOptions,
.options {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 15px;
	flex-basis: 16.666%;
	flex-shrink: 0;

	@media (max-width: 750px) {
		flex-basis: auto;
		justify-content: flex-end;
		gap: 14px;
	}
}

.item {
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	&.base {
		display: flex;
		align-items: center;
		justify-content: center;

		div {
			background-color: $primary-color;
			color: white;
			border-radius: 50%;
			display: flex;
			width: 2.5em;
			height: 2.5em;
			justify-content: center;
			align-items: center;
			font-size: 14px;
		}
	}
}

.subtitle {
	margin-top: -5px;
	font-size: 13px;
	color: $primary-color;
	font-weight: 500;
}

.iconNotification {
	cursor: pointer;
	display: block;
	color: $gray-700;
	transition: color 0.2s ease;

	&:hover {
		color: $primary-color;
	}
}

.iconHeader,
.DropdownIcon {
	width: 1.5rem;
	height: 1.5rem;
	color: currentColor;
	stroke: currentColor;
}

.itemMenu {
	padding: 10px;
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: $gray-100;
	}

	&.itemMenuActive {
		background-color: $primary-color;
		color: white;
	}
}

.dropdown_menu {
	background-color: #fff;
	position: absolute;
	top: 70px;
	right: 30px;
	z-index: 2;
	width: 15rem;
	box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	animation: fade-in 0.2s ease 0s 1 normal forwards;

	ul {
		list-style: none;
		padding-left: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin: 0;

		li {
			width: 100%;
			padding: 0.5rem 1rem;
			color: $gray-700;

			.icon {
				margin-right: 1rem;
				height: 1rem;
				width: 1rem;
				color: $gray-700;
				stroke: $gray-700;
			}

			a {
				color: $gray-700;
			}

			&:hover {
				background-color: $primary-color;
				color: #fff;
				cursor: pointer;

				.icon {
					color: #fff;
					stroke: #fff;
				}

				a {
					color: #fff;
					text-decoration: none;
				}

				&:first-child {
					background-color: white;
					color: black;
					border-radius: 5px 5px 0 0;
				}

				&:last-child {
					border-radius: 0 0 5px 5px;
				}
			}

			&:last-child {
				border-top: 1px solid $gray-300;
			}

			&:first-child {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				cursor: pointer;
				border-bottom: 1px solid $gray-300;

				&:hover {
					background-color: $primary-color;
					color: #fff;

					.subtitle {
						color: $gray-700;
					}
				}
			}
		}
	}
}

@keyframes fade-in {
	0% {
		opacity: 0;
		transform: rotateX(-100deg);
		transform-origin: top;
	}

	100% {
		opacity: 1;
		transform: rotateX(0deg);
		transform-origin: top;
	}
}
